import classnames from 'classnames';
import { Button, message, Typography } from 'antd';

import { SettingsDisabledInput } from './SettingsDisabledInput';
import { SettingsCard } from './SettingsCard';
import { FormItem, PhoneField } from 'componets/form';

import { downloadUserAgreement } from 'features/userSettings/actions';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { Rules } from 'utils/constants';

import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';

import s from './index.module.scss';
import {SettingsAddressCard} from "./SettingsAddressCard";

const WORDS = [
	'firstNameText',
	'lastNameText',
	'personalInformationText',
	'companyInformationText2',
	'downloadText',
	'userAgreementText',
	'emailAddressText',
	'agreementNotFoundText',
];
export const SettingsPersonalInformationCard = ({ userType = 'user' }) => {
	const settings = useAppSelector((state) => state.userSettings.entity);

	const t = useTranslate(WORDS);
	const isUser = userType === 'user';
	const dispatch = useAppDispatch();

	const onSaveAgreement = () => {
		dispatch(
			downloadUserAgreement({
				agreement: settings.agreement,
				fileName: `${t.userAgreementText}.pdf`,
			}),
		)
			.unwrap()
			.catch(() => {
				message.warn(t.agreementNotFoundText);
			});
	};

	return (
		<SettingsCard title={ isUser ? t.personalInformationText : t.companyInformationText2}>
			<div className={classnames(s.contentRow, s.addressRow)}>
				<SettingsDisabledInput
					className={s.col}
					name={t.firstNameText}
					value={settings.first_name}
				/>
				<SettingsDisabledInput className={s.col} name={t.lastNameText} value={settings.last_name} />
			</div>

			<div className={classnames(s.contentRow, s.addressRow, s.phoneRow)}>
				<SettingsDisabledInput className={s.col} name={t.emailAddressText} value={settings.email} />

				<div className={s.col}>
					<FormItem className={s.input} name="phone" rules={[Rules.REQUIRED, Rules.PHONE('phone')]}>
						<PhoneField isSettings />
					</FormItem>
				</div>
			</div>
			{isUser && <SettingsAddressCard /> }
			<div className={s.agreement}>
				<Typography.Text>{t.userAgreementText}</Typography.Text>
				<Button type="link" className={s.download} onClick={onSaveAgreement}>
					<DownloadIcon className={s.downloadIcon} />
					{t.downloadText}
				</Button>
			</div>
		</SettingsCard>
	);
};
